<template>
    <div class="webhook-automation-form">
        <div class="fields">
            <div class="field">
                <label>{{ $t("automation.automationName") }}: </label>
                <a-input v-model="automationName" :placeholder="$t('automation.automationName')" />
            </div>
            <div class="field">
                <label>{{ $t('auto.webhookAutomationFormMethod') }} </label>
                <CustomPicker
                    v-model="payload.method"
                    :items="methods"
                    idKey="id"
                    labelKey="label"
                    :title="$t('automation.selectMethod')"
                />
            </div>
            <div class="field">
                <label>{{ $t("automation.bodyType") }}: </label>
                <CustomPicker
                    v-model="payload.bodyType"
                    :items="bodyTypes"
                    idKey="id"
                    labelKey="label"
                    :title="$t('automation.selectBodyType')"
                />
            </div>
        </div>
        <a-divider />
        <SupsisButton primary @click="save">{{ $t("message.save") }}</SupsisButton>
    </div>
</template>
<script>
import Vue from "vue";
import SupsisTable from "../../../../components/SupsisTable.vue";
import SupsisButton from "../../Settings/components/SupsisButton.vue";
import CustomPicker from "../../../../components/pickers/CustomPicker.vue";

export default Vue.extend({
    name: "WebhookAutomationForm",
    components: { CustomPicker, SupsisTable, SupsisButton },
    data() {
        return {
            automationName: "Catch Webhook Automation 🚀",
            payload: {
                method: "POST",
                bodyType: "json",
            },

            methods: ["POST", "GET", "PUT", "DELETE"].map((x) => ({
                id: x,
                label: x,
                description: `Catch webhook via ${x} method`,
            })),
            bodyTypes: [
                ...["json", "form", "raw", "xml", "number", "boolean", "string", "mixed"].map((x) => ({
                    id: x,
                    label: x,
                    description: `Webhook request body content type: ${x}`,
                })),
                {
                    id: "none",
                    label: "none",
                    description: "No body content type",
                },
                {
                    id: "contact",
                    label: "Supsis Contact",
                    description: "You can use this to send a contact to the webhook",
                },
                {
                    id: "conversation",
                    label: "Supsis Conversation",
                    description: "You can use this to send a conversation to the webhook",
                },
            ],
        };
    },
    methods: {
        save() {
            this.$emit("save", {
                name: this.automationName,
                payload: this.payload,
            });
        },
    },
    watch: {
        "payload.method": {
            handler(newMethod) {
                if (newMethod === "GET") {
                    this.payload.bodyType = "none";
                }
                if (newMethod === "DELETE") {
                    this.payload.bodyType = "none";
                }
                if (newMethod === "POST") {
                    this.payload.bodyType = "json";
                }
                if (newMethod === "PUT") {
                    this.payload.bodyType = "json";
                }
            },
            deep: true,
        },
    },
});
</script>

<style scoped lang="scss">
.webhook-automation-form {
    display: flex;
    flex-direction: column;
    gap: 5px;

    .fields {
        display: flex;
        flex-direction: row;
        gap: 10px;
    }

    .webhook-automation-form-toolbar {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 10px;

        .field {
            display: flex;
            align-items: baseline;
            gap: 5px;
        }

        label {
            font-weight: 700;
            font-size: 16px;
        }

        .ant-select {
            width: 200px;
        }
    }
}
</style>
